<template>
	<div id="contrato">		
		<a-row type="flex" justify="space-between" align="bottom">
			<a-col :span="9" v-if="idPerfilPortal!=4">			
				<a-row>
					<span>Usuário:</span>
				</a-row>
				<a-row>
					<a-select
						show-search
						option-filter-prop="children"
						style="width: 80%"
						@change="handleChangeUsuario"
						:value="valueUsuario"
						:disabled="loading"
						:allowClear="valueUsuario!=0"
						>
						<a-select-option v-for="usuario in usuarios" :key="usuario.idUsuario">
							{{usuario.nome}}
						</a-select-option>
					</a-select>
				</a-row>
			</a-col>
			<a-col :span="(idPerfilPortal==4 ? 15 : 8)">
				<a-row>
					<span>Perfil:</span>
				</a-row>
				<a-row>
					<a-select 					
						:style="(idPerfilPortal==4 ? 'width: 40%;' : 'width: 80%;')"
						@change="handleChangePerfilTribunal"
						:value="valuePerfilTribunal"
						:disabled="loading||valueUsuario==0"
						:allowClear="(valuePerfilTribunal!=0 && valuePerfilTribunal!=null)"
						>
						<a-select-option v-for="perfilTribunal in perfisTribunal" :key="perfilTribunal.idPerfilTribunal">
							{{perfilTribunal.nome}}
						</a-select-option>
					</a-select>
				</a-row>
			</a-col>
			<a-col :span="2" style="text-align: left;">
				<a-button
					type="primary"
					class="tr-search-btn"
					style="width: 105px;"
					@click.stop.prevent="carregarContratos()"
					:disabled="loading"
				>
				Pesquisar</a-button>
			</a-col>
			<a-col :span="2" style="text-align: left;">
				<a-button
					type="primary"						
					class="tr-search-btn"
					style="width: 105px;"
					@click.stop.prevent="onNovoContrato()"
					:disabled="loading"
				>Nova Fonte</a-button>
			</a-col>
			<a-col v-if="false" :span="2" style="text-align: left;">
				<a-button
					type="primary"
					class="tr-search-btn"
					style="width: 130px;"
					@click.stop.prevent="onImportarInicial()"
					:disabled="loading"
				>
				Importar Fontes</a-button>
			</a-col>
		</a-row>

		<a-row style="height: calc(100vh - 230px); overflow-y: auto; overflow-x: auto; min-height: 100px;">
			<a-table
				:columns="columns"
				:rowKey="record => record.idContrato"
				:dataSource="data"
				:loading="{spinning:loading, tip:'Carregando...'}"
				:pagination="pagination"
				@change="handleTableChange"
				size="middle"
			>
				<template slot="complemento" slot-scope="complemento, record">
					<div>						
						<a-popover title="Dados complementares" :overlayStyle="oStyle" placement="leftTop">
							<template slot="content">
								<a-table
									id="tabelaCompl"
									:columns="columnsCompl"
									:rowKey="record => record.$id"
									:dataSource="[record]"                                    
									size="middle"
									:pagination="false"
								>
									<template slot="dataCadastro" slot-scope="dataCadastro, record">
										{{formatarDataLocal(record.dataCadastro, true, 'DD/MM/YYYY HH:mm:ss')}}
									</template>
								</a-table>
							</template>
							<a-icon type="plus-circle" class="cursor" style="margin-left: 17px;"/>
						</a-popover>
					</div>
				</template>				
				<template v-if="(idUsuarioPortal==record.idUsuario || (idPerfilPortal == 6 && habilitarFuncionalidade('PermitirAlterar'))) && ([0,5,6,11,12].includes(record.statusMonitoramento))"
					slot="editar" slot-scope="editar, record">
					<div>
						<a-tooltip>
							<template slot="title">Editar Contrato</template>
							<a-icon 
								type="form" 
								class="cursor"
								@click="editarContrato(record)"/>
						</a-tooltip>
					</div>
				</template>
			</a-table>			
		</a-row>

		<modal-component
			class="modal-component"
			title="Nova Fonte"
			ref="modalNovoContrato"
			width="62%"
			:maskClosable="false"
			:dialog-style="{ top: '5%' }"
		>	
			<a-row v-if="idPerfilPortal==6">
				<a-col :span="24">
					<a-row>
						<span class="tr-label">Cliente:</span>
					</a-row>
					<a-row>
						<a-select
							class="tr-ant-select"
							style="width: 100%"
							@change="handleClienteChange"
							:disabled="loading"
							:value="valueCliente"
							:allowClear="(valueCliente!=null && valueCliente!=undefined)"
							>
							<a-select-option v-for="cli in clientes" :key="cli.idCliente">
								{{cli.nome}}
							</a-select-option>
						</a-select>
					</a-row>
				</a-col>
			</a-row>
			<a-row v-if="idPerfilPortal==6">
				<a-col :span="24">
					<a-row>
						<span class="tr-label">Usuário:</span>
					</a-row>				
					<a-row>
						<a-select
							class="tr-ant-select"
							style="width: 100%"
							@change="handleChangeUsuarioModal"
							:value="valueUsuarioModal"
							:allowClear="(valueUsuarioModal!=null && valueUsuarioModal!=undefined)"
							:disabled="loading"
							>
							<a-select-option v-for="usu in usuariosModal" :key="usu.idUsuario">
								{{usu.nome}}
							</a-select-option>
						</a-select>
					</a-row>
				</a-col>
			</a-row>
			<a-row>
				<a-col :span="24">						
					<span class="tr-label">Perfil:</span>
					<a-select
						placeholder="Selecione o perfil"
						class="tr-ant-select"
						style="width: 100%"
						@change="handleChangePerfilTribunalModal"
						:value="valuePerfilTribunalModal"
						:disabled="loadingModal"
						>
						<a-select-option v-for="perfilTribunal in perfisTribunalModal" :key="perfilTribunal.idPerfilTribunal">
							{{perfilTribunal.nome}}
						</a-select-option>
					</a-select>
					<a-divider orientation="left">Filtro:</a-divider>
				</a-col>
			</a-row>
			<a-row type="flex" justify="space-between" :gutter="40">				
				<a-col :span="6">
					<a-row>
						<span>UF:</span>
					</a-row>
					<a-row>
						<a-select
							class="tr-ant-select"
							style="width: 80%"
							@change="handleChangeUf"
							:value="valueUF"
							:disabled="loadingModal"
							:allowClear="valueUF!='TODOS'"
							>
							<a-select-option v-for="uf in ufs" :key="uf.key">
								{{uf.valor}}
							</a-select-option>
						</a-select>
					</a-row>
				</a-col>
				<a-col :span="6">
					<a-row>
						<span>Justiça:</span>
					</a-row>
					<a-row>
						<a-select
							class="tr-ant-select"
							style="width: 80%"
							@change="handleChangeJustica"
							:value="valueJustica"
							:disabled="loadingModal"
							:allowClear="valueJustica!='TODOS'"
							>
							<a-select-option value="TODOS">TODOS</a-select-option>
							<a-select-option value="ESTADUAL">ESTADUAL</a-select-option>
							<a-select-option value="FEDERAL">FEDERAL</a-select-option>
							<a-select-option value="TRABALHISTA">TRABALHISTA</a-select-option>
						</a-select>
					</a-row>
				</a-col>
				<a-col :span="6">
					<a-row>
						<span>Sistema:</span>
					</a-row>
					<a-row>
						<a-select
							class="tr-ant-select"
							style="width: 80%"
							@change="handleChangeSistema"
							:value="valueSistema"
							:disabled="loadingModal"
							:allowClear="valueSistema!='TODOS'"
							>
							<a-select-option value="TODOS">TODOS</a-select-option>
							<a-select-option value="EPROC">EPROC</a-select-option>
							<a-select-option value="PJE">PJE</a-select-option>
							<a-select-option value="PROJUDI">PROJUDI</a-select-option>
							<a-select-option value="TJ">TJ</a-select-option>
						</a-select>
					</a-row>
				</a-col>
				<a-col :span="6">
					<a-row>
						<span>Instância:</span>
					</a-row>
					<a-row>
						<a-select
							class="tr-ant-select"
							style="width: 80%"
							@change="handleChangeInstancia"
							:value="valueInstancia"
							:disabled="loadingModal"
							:allowClear="valueInstancia!='TODOS'"
							>
							<a-select-option value="TODOS">TODOS</a-select-option>
							<a-select-option value="1">1º</a-select-option>
							<a-select-option value="2">2º</a-select-option>
						</a-select>
					</a-row>
				</a-col>
			</a-row>
			<a-row style="height: calc(100vh - 550px); overflow-y: auto; overflow-x: auto; min-height: 196px;">
				<a-table						
					:rowSelection="rowSelection"
					:columns="columnsModal"
					:rowKey="record => record.id_produto_tribunal_pol"
					:dataSource="dataFontes"
					:loading="{spinning:loadingModal, tip:'Carregando...'}"
					:pagination="false"
					size="small"
				>
					<template slot="tipoAutenticacao" slot-scope="tipoAutenticacao, record">
						{{getTipoAutenticacao(record.tipoAutenticacao)}}
					</template>
				</a-table>
			</a-row>
			<span slot="buttons">
				<a-row type="flex" align="middle">
					<a-col :span="12" style="text-align: left;">
						<span v-if="false" style="margin-left: 15px;">Qtd: {{dataFontes.length}}</span>
					</a-col>
					<a-col :span="12">
						<a-row type="flex" justify="end" align="middle" :gutter="40">
							<a-col>
								<a-button key="back" class="contrato-form-button" @click.prevent="handleCancelCadFonte()">Retornar</a-button>
							</a-col>
							<a-col>
								<a-button
									:disabled="rowSelection.selectedRowKeys.length<=0 || this.valuePerfilTribunalModal==null"
									key="submit"
									class="contrato-form-button"
									type="primary"
									@click.prevent="onNovoContratoLoginSenha()"
								>Avançar</a-button>
							</a-col>
						</a-row>
					</a-col>
				</a-row>
			</span>
		</modal-component>

		<modal-component
			class="modal-component"
			title="Nova Fonte"
			ref="modalLoginSenhaContrato"
			width="95%"
			:maskClosable="false"
			:zIndex="1001"
			:dialog-style="{ top: '5%' }"
		>	
			<a-row>
				<span>Perfil selecionado:</span>				
			</a-row>
			<a-row style="margin-bottom: 10px;">					
				<a-input 						
					:value="nomePerfilTribunalSelecionado"
					:disabled="true"
					readOnly
				/>
			</a-row>
			<a-row style="height: calc(100vh - 450px); overflow-y: auto; overflow-x: auto; min-height: 290px;">
				<a-table						
					:columns="columnsModalLoginSenha"
					:rowKey="record => record.id_produto_tribunal_pol"
					:dataSource="dataModalLoginSenha"
					:loading="{spinning:loadingModalLoginSenha, tip:'Carregando...'}"
					:pagination="false"						
					size="small"
				>
					<template
						v-for="col in ['login', 'senha', 'arquivo']"
						:slot="col"
						slot-scope="text, record"
						>
						<div :key="col" v-if="col=='login'">
							<a-input
								:maxLength=50
								v-if="record.editable"
								style="margin: -5px 0"
								:value="text"
								@change="e => handleChangeEditar(e.target.value, record.key, col)"
							/>
							<template v-else>
								{{ text }}
							</template>
						</div>
						<div :key="col" v-if="col=='senha'">
							<a-input-password
								:maxLength=30
								v-if="record.editable"
								style="margin: -5px 0"
								:value="text"
								@change="e => handleChangeEditar(e.target.value, record.key, col)"
							/>
							<template v-else>
								{{ formatarCampoSenhaGrid(text) }}
							</template>
						</div>
						<div :key="col" v-if="col=='arquivo'">
							<a-upload
								v-if="record.editable && record.tipoAutenticacao == 1"
								:file-list="arquivoListUpload"								
								:before-upload="file => beforeUploadArquivo(file, record)"
								accept=".jpg,.jpeg,.png"
							>
								<a-button> <a-icon type="upload"/></a-button>
							</a-upload>
							<a-upload
								v-if="record.editable && record.tipoAutenticacao == 2"
								:file-list="arquivoListUpload"								
								:before-upload="file => beforeUploadArquivo(file, record)"
								accept=".pfx"
							>
								<a-button> <a-icon type="upload"/></a-button>
							</a-upload>
							<span v-if="record.image64.length > 10">{{`${record.image64.substring(1, 7)}...`}}</span>
						</div>
						<div :key="col" v-if="col=='hash'">
							<a-input
								:maxLength=50
								v-if="record.editable && (record.tipoAutenticacao == 1 || record.tipoAutenticacao == 2)"
								style="margin: -5px 0"
								:value="text"
								@change="e => handleChangeEditar(e.target.value, record.key, col)"
							/>
							<template v-else>
								{{ text }}
							</template>
						</div>
					</template>
					<template slot="operacao" slot-scope="text, record">
						<div>
							<span v-if="record.editable">
								<a @click="() => save(record.key)">Salvar&nbsp;&nbsp;</a>
								<a-popconfirm title="Deseja cancelar?" @confirm="() => cancel(record.key)">
									<a>Cancelar</a>
								</a-popconfirm>
							</span>
							<span v-if="!record.editable">
								<template slot="title">Editar registro</template>
								<a :disabled="editingKey !== ''" @click="() => edit(record.key)">Editar&nbsp;&nbsp;</a>									
							</span>
							<span v-if="!record.editable">									
								<a-popconfirm title="Deseja excluir?" @confirm="() => excluir(record.key)">										
									<a :disabled="editingKey !== ''">Excluir</a>
								</a-popconfirm>
							</span>
						</div>
					</template>
				</a-table>
			</a-row>
			<span slot="buttons">
				<a-row type="flex" align="middle">
					<a-col :span="12" style="text-align: left;">
						<span v-if="false" style="margin-left: 15px;">Qtd: {{dataModalLoginSenha.length}}</span>
					</a-col>
					<a-col :span="12">
						<a-row type="flex" justify="end" align="middle" :gutter="40">
							<a-col>
								<a-button :disabled="editingKey !== ''" key="back" class="contrato-form-button" @click.prevent="handleCancelModLoginSenha()">Retornar</a-button>
							</a-col>
							<a-col>
								<a-button
									:disabled="editingKey !== ''"
									key="submit"
									class="contrato-form-button"
									type="primary"
									@click.prevent="onNovoContratoTermoAceite()"
								>Avançar</a-button>
							</a-col>
						</a-row>
					</a-col>
				</a-row>
			</span>
		</modal-component>

		<modal-component
			class="modal-component"
			title="Nova Fonte"
			ref="modalSalvarContrato"
			width="50%"
			:maskClosable="false"
			:zIndex="1002"
			:dialog-style="{ top: '5%' }"
		>
			<a-row :style="'height: calc(100vh - '+reducao+'px); overflow-y: auto; overflow-x: hidden; min-height: 100px;'">
				<a-row>
					<span>Fontes selecionada(s):</span>				
				</a-row>
				<a-row style="margin-bottom: 12px;">					
					<a-table							
						:columns="columnsModal"
						:rowKey="record => record.id_produto_tribunal_pol"
						:dataSource="dataModalLoginSenha"
						:loading="{spinning:loadingModalLoginSenha, tip:'Carregando...'}"
						:pagination="false"
						size="small"
					>
					</a-table>
				</a-row>
			</a-row>
			<a-row style="margin-top: 15px;">				
				<a-col :span="24" style="text-align: left; background-color: #eaeaea;">
					<div style="margin: 15px 20px 10px 20px;">							
						<span style="font-weight: 400; font-size: 16px;" v-html="textoTermo"/>
					</div>
				</a-col>					
			</a-row>
			<a-row style="margin-top: 5px;">
				<a-checkbox @change="onChangeCheck" :checked="termoAceite">
					Li e aceito os termos
				</a-checkbox>
			</a-row>
			<span slot="buttons">
				<a-row type="flex" align="middle">
					<a-col :span="12" style="text-align: left;">							
					</a-col>
					<a-col :span="12">
						<a-row type="flex" justify="end" align="middle" :gutter="40">
							<a-col>
								<a-button key="back" class="contrato-form-button" @click.prevent="handleCancelModTermoAceite()">Retornar</a-button>
							</a-col>
							<a-col>
								<a-button
									key="submit"
									class="contrato-form-button"
									type="primary"
									:disabled="!termoAceite"
									@click.prevent="onNovoContratoTermoSalvar()"
								>Salvar</a-button>
							</a-col>
						</a-row>
					</a-col>
				</a-row>
			</span>
		</modal-component>

		<modal-component
			class="modal-component"
			title="Editar Fonte"
			ref="modalEditarFonte"
			width="50%"
			:maskClosable="false"
			:dialog-style="{ top: '5%' }"
		>
			<a-row>
				<a-col :span="10">
					<span>Perfil:</span>
					<a-input							
						:value="nomePerfilTribunalSelecionado"
						:disabled="true"
						readOnly
					>
						<a-icon slot="prefix" type="user"/>
					</a-input>
				</a-col>
				<a-col :span="10" :offset="2">
					<span>Fonte:</span>
					<a-input
						:value="nomeFontesSelecionadas"
						:disabled="true"
						readOnly
					>
						<a-icon slot="prefix" type="folder"/>
					</a-input>
				</a-col>
			</a-row>
			<a-row>
				<a-col :span="10">
					<span class="tr-label">Login:</span>
					<a-input
						:maxLength=50
						placeholder="Insira o login do perfil"
						v-model="contrato.login"
						v-ant-input-focus
						:allowClear="contrato.login!=''"
					>
						<a-icon slot="prefix" type="contrato"/>
					</a-input>
				</a-col>
				<a-col :span="10" :offset="2">
					<span class="tr-label">Senha:</span>
					<a-input-password
						:maxLength=30
						placeholder="Insira a senha do perfil"
						v-model="contrato.senha"
						:allowClear="contrato.senha!=''"
					>
						<a-icon slot="prefix" type="lock"/>
					</a-input-password>
				</a-col>
			</a-row>
			<a-row v-if="fonteTipoAutenticacao == 1 || fonteTipoAutenticacao == 2">
				<a-col :span="10">
					<span class="tr-label">Arquivo</span>	
					<br>
					<a-upload
						v-if="fonteTipoAutenticacao == 1"
						:file-list="arquivoListUpload"								
						:before-upload="file => beforeUploadArquivoEdit(file)"
						accept=".jpg,.jpeg,.png"
					>
						<a-button> <a-icon type="upload"/></a-button>
					</a-upload>
					<a-upload
						v-if="fonteTipoAutenticacao == 2"
						:file-list="arquivoListUpload"								
						:before-upload="file => beforeUploadArquivoEdit(file)"
						accept=".pfx"
					>
						<a-button> <a-icon type="upload"/></a-button>
					</a-upload>				
					<span v-if="contrato.image64Autenticacao != undefined && contrato.image64Autenticacao != null && contrato.image64Autenticacao.length > 10">{{`${contrato.image64Autenticacao.substring(1, 90)}...`}}</span>				
				</a-col>				
				<!--<a-col :span="10" :offset="2">
					<span class="tr-label">Hash:</span>
					<a-input
						:maxLength=50
						placeholder="Insira o hash"
						v-model="hashValue"
						v-ant-input-focus
						:allowClear="hashValue!=''"
						@change="changeHash"
					>
						<a-icon slot="prefix" type="contrato"/>
					</a-input>
				</a-col>-->
			</a-row>
			<a-row style="margin-top: 10px;">				
				<a-col :span="24" style="text-align: left; background-color: #eaeaea;">
					<div style="margin: 15px 20px 10px 20px;">							
						<span style="font-weight: 400; font-size: 16px;" v-html="textoTermo"/>
					</div>
				</a-col>
			</a-row>
			<a-row style="margin-top: 5px;">
				<a-checkbox @change="onChangeCheck" :checked="termoAceite">
					Li e aceito os termos
				</a-checkbox>
			</a-row>
			<span slot="buttons">
				<a-row type="flex" align="middle">
					<a-col :span="12" style="text-align: left;">
						<a-switch style="margin-left: 15px;" defaultChecked v-model="contrato.status" @change="handlerSwitchChange">
							<a-icon type="check" slot="checkedChildren"/>
							<a-icon type="close" slot="unCheckedChildren"/>
						</a-switch>
						<span style="margin-left: 10px;">Situação</span>
					</a-col>
					<a-col :span="12">
						<a-row type="flex" justify="end" align="middle" :gutter="40">
							<a-col>
								<a-button key="back" class="contrato-form-button" @click.prevent="handleCancelEditarContrato()">Retornar</a-button>
							</a-col>
							<a-col>
								<a-button
									key="submit"
									class="contrato-form-button"
									type="primary"
									:disabled="!termoAceite"
									@click.prevent="handleSalvarEditarContrato()"
								>Salvar</a-button>
							</a-col>
						</a-row>
					</a-col>
				</a-row>
			</span>
		</modal-component>

		<modal-component
			class="modal-component"
			title="Importar Inicial"
			ref="modalImportarInicial"
			width="40%"
			:maskClosable="false"
			:dialog-style="{ top: '5%' }"
		>
			<a-row v-if="idPerfilPortal==6">
				<a-col :span="24">
					<a-row>
						<span class="tr-label">Cliente:</span>
					</a-row>
					<a-row>
						<a-select
							class="tr-ant-select"
							style="width: 100%"
							@change="handleClienteChange"
							:disabled="loading"
							:value="valueCliente"
							:allowClear="(valueCliente!=null && valueCliente!=undefined)"
							>
							<a-select-option v-for="cli in clientes" :key="cli.idCliente">
								{{cli.nome}}
							</a-select-option>
						</a-select>
					</a-row>
				</a-col>
			</a-row>
			<a-row v-if="idPerfilPortal==6">
				<a-col :span="24">
					<a-row>
						<span class="tr-label">Usuário:</span>
					</a-row>				
					<a-row>
						<a-select
							class="tr-ant-select"
							style="width: 100%"
							@change="handleChangeUsuarioModal"
							:value="valueUsuarioModal"
							:allowClear="(valueUsuarioModal!=null && valueUsuarioModal!=undefined)"
							:disabled="loading"
							>
							<a-select-option v-for="usu in usuariosModal" :key="usu.idUsuario">
								{{usu.nome}}
							</a-select-option>
						</a-select>
					</a-row>
				</a-col>
			</a-row>
			<a-row>
				<a-col :span="24">						
					<span class="tr-label">Perfil:</span>
					<a-select 					
						style="width: 100%;"
						@change="handleChangePerfilTribunalModalImport"
						:value="valuePerfilTribunalModal"
						:disabled="loadingModal"
						>
						<a-select-option v-for="perfilTribunal in perfisTribunalModal" :key="perfilTribunal.idPerfilTribunal">
							{{perfilTribunal.nome}}
						</a-select-option>
					</a-select>
				</a-col>
			</a-row>
			<span slot="buttons">
				<a-row type="flex" align="middle">
					<a-col :span="12" style="text-align: left;">
						<a-row>
							<span style="font-weight: normal !important;">*Observação: Uma planilha será direcionada ao perfil de Advogado e a outra será direcionada ao perfil de Representante/Procurador.</span>
						</a-row>
					</a-col>
					<a-col :span="12">
						<a-row type="flex" justify="end" align="middle" :gutter="40">							
							<a-col>
								<a-button
									type="primary"
									class="tr-search-btn"
									style="width: 145px;"
									@click.prevent="onDownloadPlanModelo()"
									:disabled="loading"
									>
									Download Planilha</a-button>
							</a-col>
							<a-col>
								<a-button
									type="primary"
									class="tr-search-btn"
									style="width: 145px;"
									@click.stop.prevent="onCarregarPlanilha()"
									:disabled="loading"
									>
									Carregar Planilha</a-button>
							</a-col>
						</a-row>
					</a-col>
				</a-row>
			</span>
		</modal-component>

		<modal-component
			class="modal-component"
			title="Carregar Planilha"
			ref="modalCarregarPlanilha"
			width="40%"
			:maskClosable="false"
			:dialog-style="{ top: '5%' }"
		>
			<a-row>				
				<a-upload :file-list="fileListUpload" :remove="handleRemoveFile" :before-upload="beforeUploadFile" accept=".xlsx,.xls">
      		<a-button> <a-icon type="upload"/> Selecionar Arquivo </a-button>
    		</a-upload>
			</a-row>
			<a-row style="margin-top: 10px;">				
				<a-col :span="24" style="text-align: left; background-color: #eaeaea;">
					<div style="margin: 15px 20px 10px 20px;">							
						<span style="font-weight: 400; font-size: 16px;" v-html="textoTermo"/>
					</div>
				</a-col>
			</a-row>
			<a-row style="margin-top: 5px;">
				<a-checkbox @change="onChangeCheck" :checked="termoAceite">
					Li e aceito os termos
				</a-checkbox>
			</a-row>
			<span slot="buttons">
				<a-row type="flex" align="middle">					
					<a-col :span="23" >
						<a-row type="flex" justify="end" align="middle" :gutter="40">
							<a-col>
								<a-button
									type="primary"
									class="tr-search-btn"
									style="width: 130px;"
									@click.prevent="onCarregarPlanilhaImport()"
									:disabled="loading"
									>
									Enviar</a-button>
							</a-col>
							<!-- <a-col>
									<a-button key="back" class="cliente-form-button" @click.prevent="handleCancel">Retornar</a-button>
							</a-col> -->
						</a-row>
					</a-col>
				</a-row>
			</span>
		</modal-component>
	</div>
</template>

<script>
import IntimacaoWebApi from "@/API/intimacaoWebApi";
import ModalComponent from "@/components/ModalComponent";
import { SET_VALUEPERFILTRIBUNAL } from "@/store/mutations";
import { LOAD_QTDAPROVACAO } from "@/store/actions";
import moment from "moment";
import { showNotificationError } from "@/util/showNotification";
import { showNotificationSucess } from "@/util/showNotification";
import Helpers from "@/util/Helpers";

const columns = [
	{
		title: "Usuário",
		dataIndex: "nomeUsuario",
		sorter: (a, b) => a.nomeUsuario.localeCompare(b.nomeUsuario),
		width: "15%",
		scopedSlots: { customRender: "nomeUsuario" }
	},
	{
		title: "Perfil",
		dataIndex: "nomePerfilTribunal",
		sorter: (a, b) => a.nomePerfilTribunal.localeCompare(b.nomePerfilTribunal),
		width: "15%",
		scopedSlots: { customRender: "nomePerfilTribunal" }
	},
	{
		title: "Fonte",
		dataIndex: "nomeFonte",
		sorter: (a, b) => a.nomeFonte.localeCompare(b.nomeFonte),
		width: "15%",
		scopedSlots: { customRender: "nomeFonte" }
	},
	{
		title: "UF",
		dataIndex: "uf",
		sorter: (a, b) => a.uf.localeCompare(b.uf),
		width: "5%",
		scopedSlots: { customRender: "uf" }
	},
	// {
	// 	title: "Justiça",
	// 	dataIndex: "justica",
	// 	sorter: (a, b) => a.justica.localeCompare(b.justica),
	// 	width: "7%",
	// 	scopedSlots: { customRender: "justica" }
	// },
	// {
	// 	title: "Sistema",
	// 	dataIndex: "sistema",
	// 	sorter: (a, b) => a.sistema.localeCompare(b.sistema),
	// 	width: "7%",
	// 	scopedSlots: { customRender: "sistema" }
	// },
	// {
	// 	title: "Instância",
	// 	dataIndex: "obs_grau",
	// 	sorter: (a, b) => a.obs_grau.localeCompare(b.obs_grau),
	// 	width: "5%",
	// 	scopedSlots: { customRender: "obs_grau" }
	// },
	{
		title: "Status",
		dataIndex: "descricaoStatusMonitoramento",
		sorter: (a, b) => a.descricaoStatusMonitoramento.localeCompare(b.descricaoStatusMonitoramento),		
		width: "10%",
		scopedSlots: { customRender: "descricaoStatusMonitoramento" },
		// customCell:(record,index)=>{
	    // return{
        //         style: {color: record.statusMonitoramento <= 2 ? "red" : "blue"},
		//     }
		// }
	},
	{
		title: "Complemento",
		width: "9%",
		align: "center",
		scopedSlots: { customRender: "complemento" }
	},
	{		
		title: "Editar",
		dataIndex: "editar",
		width: "5%",
		align: "center",
		scopedSlots: { customRender: "editar" }
	}
];

const columnsCompl = [	
  {
		title: "Justiça",
		dataIndex: "justica",
		sorter: (a, b) => a.justica.localeCompare(b.justica),		
		scopedSlots: { customRender: "justica" }
	},
	{
		title: "Sistema",
		dataIndex: "sistema",
		sorter: (a, b) => a.sistema.localeCompare(b.sistema),
		scopedSlots: { customRender: "sistema" }
	},
	{
		title: "Instância",
		dataIndex: "obs_grau",
		sorter: (a, b) => a.obs_grau.localeCompare(b.obs_grau),
		scopedSlots: { customRender: "obs_grau" }
	},
	{
		title: "Data Cadastro",
		dataIndex: "dataCadastro",
        align: "center",
        scopedSlots: { customRender: "dataCadastro" },
		sorter: (a, b) => moment(a.dataCadastro) - moment(b.dataCadastro)
	},
	{
		title: "Mensagem",
		dataIndex: "mensagemPol",
		align: "left"
	}
];

const columnsModal = [
	{
		title: "Fonte",
		dataIndex: "siglaKurier",
		sorter: (a, b) => a.siglaKurier.localeCompare(b.siglaKurier),		
		scopedSlots: { customRender: "siglaKurier" }
	},
	{
		title: "UF",
		dataIndex: "uf",
		sorter: (a, b) => a.uf.localeCompare(b.uf),
		width: 60,
		scopedSlots: { customRender: "uf" }
	},
	{
		title: "Justiça",
		dataIndex: "justica",
		sorter: (a, b) => a.justica.localeCompare(b.justica),
		width: 100,
		scopedSlots: { customRender: "justica" }
	},
	{
		title: "Sistema",
		dataIndex: "sistema",
		sorter: (a, b) => a.sistema.localeCompare(b.sistema),
		width: 100,
		scopedSlots: { customRender: "sistema" }
	},
	{
		title: "Instância",
		dataIndex: "obs_grau",
		sorter: (a, b) => a.obs_grau.localeCompare(b.obs_grau),
		width: 100,
		scopedSlots: { customRender: "obs_grau" }
	},
	{
		title: "Autenticação",
		dataIndex: "tipoAutenticacao",
		sorter: (a, b) => a.tipoAutenticacao.localeCompare(b.tipoAutenticacao),
		width: 140,
		scopedSlots: { customRender: "tipoAutenticacao" }
	}
];

const columnsModalLoginSenha = [
	{
		title: "Fonte",
		dataIndex: "siglaKurier",
		sorter: (a, b) => a.siglaKurier.localeCompare(b.siglaKurier),		
		scopedSlots: { customRender: "siglaKurier" }
	},
	{
		title: "UF",
		dataIndex: "uf",
		sorter: (a, b) => a.uf.localeCompare(b.uf),
		width: "5%",
		scopedSlots: { customRender: "uf" }
	},
	{
		title: "Justiça",
		dataIndex: "justica",
		sorter: (a, b) => a.justica.localeCompare(b.justica),
		width: "10%",
		scopedSlots: { customRender: "justica" }
	},
	{
		title: "Sistema",
		dataIndex: "sistema",
		sorter: (a, b) => a.sistema.localeCompare(b.sistema),
		width: "9%",
		scopedSlots: { customRender: "sistema" }
	},
	{
		title: "Instância",
		dataIndex: "obs_grau",
		sorter: (a, b) => a.obs_grau.localeCompare(b.obs_grau),
		width: "8%",
		align: "center",
		scopedSlots: { customRender: "obs_grau" }
	},
	{
		title: "Login",
		dataIndex: "login",
		width: "13%",
		scopedSlots: { customRender: "login" }
	},
	{
		title: "Senha",
		dataIndex: "senha",
		width: "13%",
		scopedSlots: { customRender: "senha" }
	},
	{
		title: "Arquivo",
		dataIndex: "arquivo",
		width: "6%",
		scopedSlots: { customRender: "arquivo" }
	},
	//{
	//	title: "Hash",
	//	dataIndex: "hash",
	//	width: "6%",
	//	scopedSlots: { customRender: "hash" }
	//},
	{		
		title: "Operação",
		dataIndex: "operacao",
		width: "10%",
		align: "center",
		scopedSlots: { customRender: "operacao" }
	}
];

export default {	
	name: "contrato",
	data() {		
		return {
			idTela: 4,
			data: [],
			dataFontes: [],
			dataModalLoginSenha: [],
			listaFontesFiltrada: [],
			textoTermo: '',
			pagination: {},
			loading: false,
			loadingModal: false,
			loadingModalLoginSenha: false,
			ufs: [],
			fontesPolCompleta: [],
			columns,
			columnsCompl,
			columnsModal,
			columnsModalLoginSenha,
			oStyle: {
				width: "30%"
			},
			//fonteSelRowsModal: null,
			rowSelection: {
				type:'checkbox',
				onChange: (selectedRowKeys, selectedRows) => {					
					this.rowSelection.selectedRowKeys = selectedRowKeys;					
					//this.fonteSelRowsModal = selectedRows.length == 0 ? null : selectedRows;
				},
				selectedRowKeys: [],
			},
			contrato:{
				idContrato: 0,
				idProduto: "",
				idPerfilTribunal: 0,
				login: "",
				senha: "",
				idUsuario: 0,
				status: true,
				statusMonitoramento: 0,
				idUsuarioAlteracao: 0,
				mensagemPol: "",
				image64Autenticacao: null
			},
			perfisTribunal: [],
			perfisTribunalModal: [],
			perfisTribunalImport: [],
			fileListUpload: [],
			arquivoListUpload: [],
			termoAceite: false,
			valuePerfilTribunal: null,
			valuePerfilTribunalModal: null,
			//valuePerfilTribunalImport: null,
			valueUF: 'TODOS',
			valueJustica: 'TODOS',
			valueSistema: 'TODOS',
			valueInstancia: 'TODOS',			
			fontesSelecionadas: '',
			nomePerfilTribunalSelecionado: '',
			editingKey: '',
			usuarios: [],
			valueUsuario: 0,
			idPerfilPortal: 0,
			idUsuarioPortal: 0,
			idClientePortal: null,
			perfilTribunalTelaClick: null,
			nomeFontesSelecionadas: '',
			reducao: 756,
			tipoPerfilTribunal: 0,
			clientes: [],
			valueCliente: null,
			usuariosModal: [],
			valueUsuarioModal: null,
			fonteTipoAutenticacao: 0,
			hashValue: null
		};
	},
	mounted() {		
		this.idUsuarioPortal = this.$store.state.auth.idUser;		
		this.idPerfilPortal = this.$store.state.auth.idPerfilPortal;
		this.idClientePortal = this.$store.state.auth.idCliente;
		this.textoTermo = this.$store.state.global.termoAceiteAdv; //Por segurança
		this.perfilTribunalTelaClick = this.$store.state.global.perfilTribunal;
		this.$store.commit(SET_VALUEPERFILTRIBUNAL, null);
		this.ufs = [{key:'TODOS', valor:'TODOS'}, {key:'BR', valor:'BR'}];
		this.ufs = this.ufs.concat(this.$store.state.global.ufs.map(h => {
							return {...h}
						}));
		this.carregarUsuarios();
		if (this.perfilTribunalTelaClick != null)
		{
			try {
				this.$root.loadingSpinner = true;
				this.handleChangeUsuario(this.idUsuarioPortal);
				setTimeout(x => {
					this.handleChangePerfilTribunal(this.perfilTribunalTelaClick.idPerfilTribunal);
					setTimeout(x => {
						this.onNovoContrato();						
						setTimeout(x => {										
							this.handleChangePerfilTribunalModal(this.perfilTribunalTelaClick.idPerfilTribunal);
							this.perfilTribunalTelaClick = null;
							this.$root.loadingSpinner = false;
						}, 3000);
					}, 3000);
				}, 3000);
			}
			catch (err) {
				this.$root.loadingSpinner = false;
			}
		}
		else
		{
			if (this.idPerfilPortal == 4)
				this.handleChangeUsuario(this.idUsuarioPortal);

			try {
				this.$root.loadingSpinner = true;
				setTimeout(x => {
					this.carregarContratos();
					this.$root.loadingSpinner = false;
				}, 3000);
			}
			catch (err) {
				this.$root.loadingSpinner = false;
			}
		}
		if (this.idPerfilPortal == 6)
			this.recuperarClientes();
	},	
	methods: {
		changeHash(){
			this.contrato.image64Autenticacao = null;
		},
		getTipoAutenticacao(value) {
			let aux = 'Normal'
			switch (value) {
				case 1:	aux = 'QRCode';
								break;
				case 2:	aux = 'Certificado Digital';
								break;
			}

			return aux;
		},
		habilitarFuncionalidade(funcionalidade) {
			let retorno = Helpers.funcionalidadeAutorizada({
				idTela: this.idTela,
				funcionalidade: funcionalidade
			});
			return retorno;
		},
		carregarUsuarios(){
			this.loading = true;
			IntimacaoWebApi.getUsersExibicao({ idCliente: this.idClientePortal }).then(res => {
				this.loading = false;
				if (res.data.statusCode != 200) {
					showNotificationError(this, "Cadastro de Fontes", res.data.errorMessage);
					return;
				} else if (typeof res.data.result == "string") {
					showNotificationSucess(this, "Cadastro de Fontes", res.data.result);
				} else {
					this.usuarios.push({ idUsuario: 0, nome: 'Todos' });
					this.usuarios.push.apply(this.usuarios, res.data.result.map(h => {
							return { idUsuario: h.idUsuario, nome: h.nome }
						}));
				}
			})
			.catch(res => {
				this.loading = false;
				showNotificationError(this, "Cadastro de Fontes", "Erro ao tentar carregar usuários.");
			});
		},
		handleChangeUsuario(value) {
			this.data = [];
			this.perfisTribunal = [];			
			this.valuePerfilTribunal = null;
			this.valueUsuario = value == undefined ? 0 : value;
			if (this.valueUsuario != 0)
				this.getPerfilTribunalExibicaoUsuario(this.valueUsuario);
		},
		handleChangePerfilTribunal(value) {
			this.data = [];
			this.valuePerfilTribunal = value == undefined ? 0 : value;		
		},
		carregarContratos() {			
			this.loading = true;
			IntimacaoWebApi.recuperarContratoExibicao(this.valueUsuario, (this.valuePerfilTribunal==null ? 0 : this.valuePerfilTribunal), (this.idClientePortal==null ? 0 : this.idClientePortal))
				.then(res => {
					this.loading = false;
					if (res.data.statusCode != 200) {
						showNotificationError(this, "Cadastro de Fontes", res.data.errorMessage);
						return;
					} else if (typeof res.data.result == "string") {
						showNotificationSucess(this, "Cadastro de Fontes", res.data.result);
					} else {					
						this.data = res.data.result;
						this.pagination = { current: 1 };
					}				
				})
				.catch(res => {
					this.loading = false;
					this.$root.loadingSpinner = false;
					showNotificationError(this, "Cadastro de Fontes", "Erro ao tentar carregar fontes.");
				});
		},
		handleChangePerfilTribunalModal(value) {
			this.dataFontes = [];
			this.valuePerfilTribunalModal = value;
			this.rowSelection.selectedRowKeys = [];
			this.valueUF = 'TODOS';
			this.valueJustica = 'TODOS';
			this.valueSistema = 'TODOS';
			this.valueInstancia = 'TODOS';
			this.tipoPerfilTribunal = 0;
			let perfilTribunal = this.perfisTribunalModal.find(a => a.idPerfilTribunal == this.valuePerfilTribunalModal);
			if (perfilTribunal != undefined) {
				if (perfilTribunal.perfil.toUpperCase() == 'ADVOGADO')
				{
					this.tipoPerfilTribunal = 1;
					this.textoTermo = this.$store.state.global.termoAceiteAdv;
				}
				else
				{
					this.tipoPerfilTribunal = 2;
					this.textoTermo = this.$store.state.global.termoAceiteRep;
				}
			}
			this.recuperarContratosFiltroCad();
		},
		handleChangePerfilTribunalModalImport(value) {			
			this.valuePerfilTribunalModal = value;
			let perfilTribunal = this.perfisTribunalModal.find(a => a.idPerfilTribunal == this.valuePerfilTribunalModal);
			if (perfilTribunal != undefined) {
				if (perfilTribunal.perfil.toUpperCase() == 'ADVOGADO')
				{
					this.tipoPerfilTribunal = 1;
					this.textoTermo = this.$store.state.global.termoAceiteAdv;
				}
				else
				{
					this.tipoPerfilTribunal = 2;
					this.textoTermo = this.$store.state.global.termoAceiteRep;
				}
			}
		},
		onChangeCheck(e){
			this.termoAceite = e.target.checked;
		},
		handleTableChange(pagination, filters, sorter) {
			const pager = { ...this.pagination };
      		pager.current = pagination.current;
      		this.pagination = pager;
		},
		recuperarContratosFiltroCad() {
			this.dataFontes = [];			
			if (this.valuePerfilTribunalModal != null)
			{
				this.loadingModal = true;
				IntimacaoWebApi.recuperarContratoExibicao(this.valueUsuario, this.valuePerfilTribunalModal, (this.idClientePortal==null ? 0 : this.idClientePortal))				
					.then(res => {
						this.loadingModal = false;
						if (res.data.statusCode != 200) {
							showNotificationError(this, "Cadastro de Fontes", res.data.errorMessage);
							return;
						} else if (typeof res.data.result == "string") {
							showNotificationSucess(this, "Cadastro de Fontes", res.data.result);
						} else {
							let listaTemp = res.data.result.map(h => {
								return { ...h }
							});							
							
							let fontesPol = this.fontesPolCompleta.filter(f => f.tipoPerfilTribunal == this.tipoPerfilTribunal);
							this.listaFontesFiltrada = fontesPol.filter(f => 
								listaTemp.every( c => { 
									var key = Object.keys(c)[0];									
									return f.id_produto_tribunal_pol != c.idProduto
								})
							);
							this.dataFontes = this.listaFontesFiltrada;	
						}
					})
					.catch(res => {
						this.loading = false;
						this.$root.loadingSpinner = false;
						showNotificationError(this, "Cadastro de Fontes", "Erro ao tentar carregar fontes.");
					});
			}
		},
		recuperarFontesPOL(){
			this.loading = true;
			IntimacaoWebApi.recuperarFontesPOL({ idFontesPOL: 0 })
				.then(res => {
					this.loading = false;
					if (res.data.statusCode != 200) {
						showNotificationError(this, "Cadastro de Fontes", res.data.errorMessage);
						return;
					} else if (typeof res.data.result == "string") {
						showNotificationSucess(this, "Cadastro de Fontes", res.data.result);
					} else {
						this.fontesPolCompleta = res.data.result;
					}
				})
				.catch(res => {
					this.loading = false;
					this.$root.loadingSpinner = false;
					showNotificationError(this, "Cadastro de Fontes", "Erro ao tentar carregar fontes.");
				});
		},
		getPerfilTribunalExibicaoUsuario(idUsuarioPortal){
			this.perfisTribunal = [];			
			IntimacaoWebApi.getPerfilTribunalExibicaoUsuario(idUsuarioPortal)
				.then(res => {
					if (res.data.statusCode != 200) {
						showNotificationError(this, "Cadastro de Fontes", res.data.errorMessage);
						return;
					} else if (typeof res.data.result == "string") {
						showNotificationSucess(this, "Cadastro de Fontes", res.data.result);
					} else {
						this.perfisTribunal.push({ idPerfilTribunal: 0, nome: 'Todos' });
						this.perfisTribunal.push.apply(this.perfisTribunal, res.data.result.map(h => {
								return { idPerfilTribunal: h.idPerfilTribunal, nome: h.nome }
							}));						
						this.valuePerfilTribunal = 0;
					}
				})
				.catch(res => {
					this.loading = false;
					showNotificationError(this, "Cadastro de Fontes", "Erro ao tentar carregar perfis.");
				});
		},
		getPerfilTribunalExibicaoUsuarioModal(idUsuarioPortal){
			this.loadingModal = true;
			this.perfisTribunalModal = [];
			IntimacaoWebApi.getPerfilTribunalExibicaoUsuario(idUsuarioPortal)
				.then(res => {
					this.loadingModal = false;
					if (res.data.statusCode != 200) {
						showNotificationError(this, "Cadastro de Fontes", res.data.errorMessage);
						return;
					} else if (typeof res.data.result == "string") {
						showNotificationSucess(this, "Cadastro de Fontes", res.data.result);
					} else {
						this.perfisTribunalModal = res.data.result.map(h => {
								return { idPerfilTribunal: h.idPerfilTribunal, nome: h.nome, perfil: h.perfil }
							});
						
						this.valuePerfilTribunalModal = this.perfisTribunalModal.length == 1 ? this.perfisTribunalModal[0].idPerfilTribunal : null;
						setTimeout(x => {							
							this.handleChangePerfilTribunalModal(this.valuePerfilTribunalModal);
						}, 1000);
					}
				})
				.catch(res => {
					this.loadingModal = false;					
					showNotificationError(this, "Cadastro de Fontes", "Erro ao tentar carregar perfis.");
				});
		},
		editarContrato(contrato) {
			this.contrato.idContrato = contrato.idContrato;
			this.contrato.idProduto = contrato.idProduto;
			this.contrato.idPerfilTribunal = contrato.idPerfilTribunal;
			this.contrato.login = contrato.login;
			this.contrato.senha = contrato.senha;
			this.contrato.idUsuario = contrato.idUsuario;
			this.contrato.status = contrato.status;
			this.contrato.statusMonitoramento = contrato.statusMonitoramento;
			this.contrato.idUsuarioAlteracao = this.idUsuarioPortal;
			this.contrato.mensagemPol = contrato.mensagemPol;
			this.termoAceite = false;
			this.nomePerfilTribunalSelecionado = contrato.nomePerfilTribunal;
			this.nomeFontesSelecionadas = contrato.nomeFonte;			
			this.contrato.image64Autenticacao = contrato.image64Autenticacao != null ? contrato.image64Autenticacao.length > 40 ? contrato.image64Autenticacao : '' : '';
			this.hashValue = contrato.image64Autenticacao != null ? contrato.image64Autenticacao.length > 40 ? '' : contrato.image64Autenticacao : '';
			this.fonteTipoAutenticacao = contrato.fonteTipoAutenticacao;
			this.$refs.modalEditarFonte.showModal();
		},
		onNovoContratoLoginSenha() {
			this.editingKey = '';
			this.dataModalLoginSenha = [];

			if (this.idPerfilPortal == 6)
			{
				if (this.valueCliente == null || this.valueCliente == undefined){
					showNotificationError(this, "Cadastro de Fontes", "Cliente é um campo obrigatório");
					return;
				}
				if (this.valueUsuarioModal == null || this.valueUsuarioModal == undefined){
					showNotificationError(this, "Cadastro de Fontes", "Usuário é um campo obrigatório");
					return;
				}
			}	
			if (this.valuePerfilTribunalModal == null)			
			{
				showNotificationError(this, "Cadastro de Fontes", "Perfil é um campo obrigatório");
				return;
			}
			if (this.rowSelection.selectedRowKeys.length <= 0)
			{
				showNotificationError(this, "Cadastro de Fontes", "Selecione uma fonte na tabela!");
				return;
			}

			this.rowSelection.selectedRowKeys.forEach(e => {
				let fonte = this.listaFontesFiltrada.filter(f => {
					return f.id_produto_tribunal_pol == e
				});
				this.dataModalLoginSenha.push({ key: fonte[0].id_produto_tribunal_pol, login: '', senha: '', image64: '', hash: '', ...fonte[0] });
			});
			this.cacheData = this.dataModalLoginSenha.map(item => ({ ...item }));
			this.nomePerfilTribunalSelecionado = this.perfisTribunalModal.find(a => a.idPerfilTribunal == this.valuePerfilTribunalModal).nome;
			this.$refs.modalLoginSenhaContrato.showModal();
		},
		onNovoContratoTermoSalvar() {			
			if (this.termoAceite == false)
			{
				showNotificationError(this, "Cadastro de Fonte", "É obrigatório aceitar os termos!");
				return;
			}
			let listaContratos = [];
			this.dataModalLoginSenha.forEach(obj => {
				listaContratos.push({
					idContrato: 0,
					idProduto: obj.id_produto_tribunal_pol,
					idPerfilTribunal: this.valuePerfilTribunalModal,
					login: obj.login,
					senha: obj.senha,
					idUsuario: this.idUsuarioPortal,
					status: true,
					statusMonitoramento: 0,
					idUsuarioAlteracao: this.idUsuarioPortal,
					mensagemPol: '',
					image64Autenticacao: obj.hash != '' ? obj.hash : obj.image64
				});				
			});
			this.$root.loadingSpinner = true;			
			IntimacaoWebApi.inserirContrato(listaContratos)
				.then(res => {					
					this.$root.loadingSpinner = false;
					if (res.data.statusCode == 200) {
						showNotificationSucess(this, "Cadastro de Fontes", res.data.result);
						this.handleCancelModTermoAceite();
						this.handleCancelModLoginSenha();
						this.handleCancelCadFonte();
						this.carregarContratos();
						if (this.idPerfilPortal == 3)
						{
							this.pegarQtdAprovacaoGestor();
						}
					} else
						showNotificationError(this, "Cadastro de Fontes", res.data.errorMessage);
				})
				.catch(res => {
					this.$root.loadingSpinner = false;
					this.loading = false;
					showNotificationError(this, "Cadastro de Fontes", "Erro ao cadastrar fontes.");
				});			
		},
		handleCancelModTermoAceite() {
			this.$refs.modalSalvarContrato.handleCancel();
			this.nomeFontesSelecionadas = '';
			this.termoAceite = false;
		},
		handleCancelCadFonte() {		
			this.$refs.modalNovoContrato.handleCancel();
			this.dataFontes = [];
			this.valuePerfilTribunalModal = null;
			this.valueUF = 'TODOS';
			this.valueJustica = 'TODOS';
			this.valueSistema = 'TODOS';
			this.valueInstancia = 'TODOS';
			//this.fonteSelRowsModal = null;
			this.rowSelection.selectedRowKeys = [];
			this.nomePerfilTribunalSelecionado = '';
			this.dataModalLoginSenha = [];
			this.nomeFontesSelecionadas = '';
			this.termoAceite = false;
			this.image64Autenticacao = null;
		},		
		onNovoContrato() {
			this.valuePerfilTribunalModal = null;
			this.handleCancelCadFonte();
			this.recuperarFontesPOL();
			if (this.idPerfilPortal == 6)
			{
				this.valueCliente = null;
				this.valueUsuarioModal = null;
				this.usuariosModal = [];
				this.perfisTribunalModal = [];
			}
			else
			{
				this.getPerfilTribunalExibicaoUsuarioModal(this.idUsuarioPortal);
			}
			this.termoAceite = false;
			this.$refs.modalNovoContrato.showModal();
		},
		onImportarInicial() {	
			this.valuePerfilTribunalModal = null;
			if (this.idPerfilPortal == 6)
			{
				this.valueCliente = null;
				this.valueUsuarioModal = null;
				this.usuariosModal = [];
				this.perfisTribunalModal = [];
			}
			else
			{
				this.getPerfilTribunalExibicaoUsuarioModal(this.idUsuarioPortal);
			}
			this.termoAceite = false;
			this.$refs.modalImportarInicial.showModal();
		},
		onCarregarPlanilha() {
			if (this.idPerfilPortal == 6)
			{
				if (this.valueCliente == null || this.valueCliente == undefined){
					showNotificationError(this, "Carregar Planilha", "Cliente é um campo obrigatório");
					return;
				}
				if (this.valueUsuarioModal == null || this.valueUsuarioModal == undefined){
					showNotificationError(this, "Carregar Planilha", "Usuário é um campo obrigatório");
					return;
				}
			}
			if (this.tipoPerfilTribunal == 0){
				showNotificationError(this, "Carregar Planilha", "Perfil é um campo obrigatório");
				return;
			}
			this.fileListUpload = [];
			this.termoAceite = false;
			this.$refs.modalCarregarPlanilha.showModal();
		},	
		handleChangeUf(value) {			
			this.valueUF = value == undefined ? 'TODOS' : value;
			this.filtrarFontes();
		},
		handleChangeJustica(value) {
			this.valueJustica = value == undefined ? 'TODOS' : value;
			this.filtrarFontes();
		},
		handleChangeSistema(value) {
			this.valueSistema = value == undefined ? 'TODOS' : value;
			this.filtrarFontes();
		},
		handleChangeInstancia(value) {
			this.valueInstancia = value == undefined ? 'TODOS' : value;
			this.filtrarFontes();
		},
		handlerSwitchChange(value) {
			this.contrato.status = value;
		},
		filtrarFontes() {
			let lista = this.listaFontesFiltrada.map(h => {
							return {...h}
						});
			if (this.valueUF != 'TODOS')
				lista = lista.filter(x => {
			 		return x.uf == this.valueUF
				});
			if (this.valueJustica != 'TODOS')
				lista = lista.filter(x => {
			 		return x.justica == this.valueJustica
				});
			if (this.valueSistema != 'TODOS')
				lista = lista.filter(x => {
			 		return x.sistema == this.valueSistema
				});
			if (this.valueInstancia != 'TODOS')
				lista = lista.filter(x => {
			 		return x.obs_grau.indexOf(this.valueInstancia) > -1
				});
			this.dataFontes = lista;
		},
		handleCancelModLoginSenha(){			
			this.$refs.modalLoginSenhaContrato.handleCancel();
			this.nomePerfilTribunalSelecionado = '';
			this.dataModalLoginSenha = [];
		},
		onNovoContratoTermoAceite(){
			if ((this.editingKey !== '') || (this.dataModalLoginSenha.some(s => s.login.trim() == '' || s.senha.trim() == '')))
			{
				showNotificationError(this, "Cadastro de Fontes", "Login e senha são obrigatórios para todas as fontes!");
				return;
			}

			const fontesPendentesQrcode = this.dataModalLoginSenha.filter(s => s.tipoAutenticacao == 1 && ((s.image64 == null || s.image64.trim() == '') && (s.hash == null || s.hash.trim() == '')));
			const fontesPendentesCertificados = this.dataModalLoginSenha.filter(s => s.tipoAutenticacao == 2 && ((s.image64 == null || s.image64.trim() == '') && (s.hash == null || s.hash.trim() == '')));
			if (fontesPendentesQrcode && fontesPendentesQrcode.length > 0){
				const nomes = fontesPendentesQrcode.map(item => item.siglaKurier).join(', ');
				showNotificationError(this, "Cadastro de Fonte", "É obrigatório a imagem do QR Code para a(s) fonte(s): " + nomes);
				return;
			}
			if (fontesPendentesCertificados && fontesPendentesCertificados.length > 0){
				const nomes = fontesPendentesCertificados.map(item => item.siglaKurier).join(', ');
				showNotificationError(this, "Cadastro de Fonte", "É obrigatório o Certificado Digital para a(s) fonte(s): " + nomes);
				return;
			}

			if (this.dataModalLoginSenha.length == 1){
				this.reducao = 876;
			} else if (this.dataModalLoginSenha.length == 2){
				this.reducao = 826;
			} else if (this.dataModalLoginSenha.length == 3){
				this.reducao = 786;
			} else {
				this.reducao = 756;				
			}
			
			this.$refs.modalSalvarContrato.showModal();
		},
		handleCancelEditarContrato() {
			this.$refs.modalEditarFonte.handleCancel();
			this.contrato.idContrato = 0;
			this.contrato.idProduto = "";
			this.contrato.idPerfilTribunal = 0;
			this.contrato.login = "";
			this.contrato.senha = "";
			this.contrato.idUsuario = 0;
			this.contrato.status = true;
			this.contrato.statusMonitoramento = 0;
			this.contrato.idUsuarioAlteracao = 0;
			this.contrato.mensagemPol = "";
			this.contrato.image64Autenticacao = null;
		},
		handleCancelDownloadPlan() {
			this.$refs.modalImportarInicial.handleCancel();
			this.perfisTribunalModal = '';
		},
		handleCancelPlanImport() {
			this.$refs.modalCarregarPlanilha.handleCancel();
			this.myFilesImport = '';
		},
		async onDownloadPlanModelo(){
			if (this.idPerfilPortal == 6)
			{
				if (this.valueCliente == null || this.valueCliente == undefined){
					showNotificationError(this, "Download Planilha Modelo", "Cliente é um campo obrigatório");
					return;
				}
				if (this.valueUsuarioModal == null || this.valueUsuarioModal == undefined){
					showNotificationError(this, "Download Planilha Modelo", "Usuário é um campo obrigatório");
					return;
				}
			}
			if (this.tipoPerfilTribunal == 0){
				showNotificationError(this, "Download Planilha Modelo", "Perfil é um campo obrigatório");
				return;
			}
			this.$root.loadingSpinner = true;
			IntimacaoWebApi.downloadPlanilha(this.tipoPerfilTribunal)				
				.then(res => {
					this.$root.loadingSpinner = false;
					let data = res.data;					
					if (data !== null && typeof data !== "undefined") {
						let blob = new Blob([res.data], {
							type: "application/vnd.ms-excel"
						});
						let link = document.createElement("a");
						link.href = window.URL.createObjectURL(blob);
						if (this.tipoPerfilTribunal == 1){
							link.download = "Planilha_Modelo_Adv.xlsx";							
						}
						if (this.tipoPerfilTribunal == 2){
							link.download = "Planilha_Modelo_Rep.xlsx";
						}  
						document.body.appendChild(link);
						link.click();
						document.body.removeChild(link);
						this.handleCancelDownloadPlan();
					} else {
						showNotificationError(this, "Download Planilha", "Erro ao tentar fazer o download.");
					}
				})
				.catch(res => {					
					this.$root.loadingSpinner = false;
					showNotificationError(this, "Download Planilha", "Erro ao tentar fazer o download.");
				});
		},
		beforeUploadFile(file) {
			this.fileListUpload = [];
			this.fileListUpload = [...this.fileListUpload, file];
			return false;
		},
		imageUploaded(file) {
				return new Promise((resolve, reject) => {
						let reader = new FileReader();

						reader.onload = function () {
							let base64String = reader.result.replace("data:", "").replace(/^.+,/, "");

							if (base64String.length > 60000){								
								reject('Arquivo muito grande! Se for um QRCODE, a imagem deve conter somente o QRCODE e de tamanho 230x230 pixels');
							}
							else {
								resolve(base64String);
							}
						};

						reader.onerror = function (error) {
							reject(error);
						};

						reader.readAsDataURL(file);
				});
		},
		beforeUploadArquivo(file, record) {
			//octavio
			var isValidType = true;
			if (record.tipoAutenticacao == 1){
				isValidType = /\.(jpg|jpeg|png)$/i.test(file.name);				
			}
			if (record.tipoAutenticacao == 2){
				var isValidType = /\.(pfx)$/i.test(file.name);				
			}
			if (!isValidType) {
				showNotificationError(this, "Upload Arquivo", "Tipo de arquivo incorreto!");
				return;
			}

			record['hash'] = '';
			this.imageUploaded(file).then(base64String => {				
				let aux = this.dataModalLoginSenha.find(p => {
					return p.id_produto_tribunal_pol == record.id_produto_tribunal_pol
				});
				aux.image64 = base64String;				
    	}).catch(erro => {
				showNotificationError(this, "Upload Arquivo", erro);
			});
			
			this.arquivoListUpload = [];
			return false;
		},
		beforeUploadArquivoEdit(file) {
			//octavio
			var isValidType = true;
			if (this.fonteTipoAutenticacao == 1){
				isValidType = /\.(jpg|jpeg|png)$/i.test(file.name);				
			}
			if (this.fonteTipoAutenticacao == 2){
				var isValidType = /\.(pfx)$/i.test(file.name);				
			}
			if (!isValidType) {
				showNotificationError(this, "Upload Arquivo", "Tipo de arquivo incorreto!");
				return;
			}

			this.imageUploaded(file).then(base64String => {
				this.contrato.image64Autenticacao = base64String;				
    	}).catch(erro => {
				showNotificationError(this, "Upload Arquivo", erro);
			});

			this.hashValue = null;			
			this.arquivoListUpload = [];
			return false;
		},
		handleRemoveFile(file) {
			const index = this.fileListUpload.indexOf(file);
			const newFileList = this.fileListUpload.slice();
			newFileList.splice(index, 1);
			this.fileListUpload = newFileList;
		},	
		onCarregarPlanilhaImport(){
			if (this.fileListUpload.length <= 0){
				showNotificationError(this, "Carregar Planilha", "É obrigatório informar um arquivo!");
				return;
			}
			if (this.termoAceite == false){
				showNotificationError(this, "Carregar Planilha", "É obrigatório aceitar os termos!");
				return;
			}			
			IntimacaoWebApi.carregarPlanilha(this.tipoPerfilTribunal, this.fileListUpload[0], this.valuePerfilTribunalModal, this.idUsuarioPortal)
				.then(res => {					
					this.$root.loadingSpinner = false;
					if (res.data.statusCode == 200) {
                        showNotificationSucess(this, "Carregar Planilha", res.data.errorMessage);
						this.handleCancelPlanImport();
						this.handleCancelDownloadPlan();
					} else {
						showNotificationError(this, "Carregar Planilha", res.data.errorMessage);
					}
				})
				.catch(res => {					
					this.$root.loadingSpinner = false;
					showNotificationError(this, "Carregar Planilha", "Erro ao tentar carregar a planilha.");
				});
		},
		handleSalvarEditarContrato() {
			if (this.contrato.login.trim() == "" || this.contrato.login == null || typeof this.contrato.login == "undefined"){
				showNotificationError(this, "Cadastro de Contrato", "Login é um campo obrigatório");
				return;
			}
			if (this.contrato.senha.trim() == "" || this.contrato.senha == null || typeof this.contrato.login == "undefined"){
				showNotificationError(this, "Cadastro de Contrato", "Senha é um campo obrigatório");
				return;
			}
			if (this.termoAceite == false){
				showNotificationError(this, "Cadastro de Fonte", "É obrigatório aceitar os termos!");
				return;
			}
			if (this.fonteTipoAutenticacao == 1 && ((this.contrato.image64Autenticacao == null || this.contrato.image64Autenticacao.trim() == '') && (this.hashValue == null || this.hashValue.trim() == ''))){
				showNotificationError(this, "Cadastro de Fonte", "É obrigatório a imagem do QR Code!");
				return;
			}
			if (this.fonteTipoAutenticacao == 2 && ((this.contrato.image64Autenticacao == null || this.contrato.image64Autenticacao.trim() == '') && (this.hashValue == null || this.hashValue.trim() == ''))){
				showNotificationError(this, "Cadastro de Fonte", "É obrigatório o Certificado Digital!");
				return;
			}

			this.contrato.image64Autenticacao = this.hashValue != null ? this.hashValue : this.contrato.image64Autenticacao;

			this.$root.loadingSpinner = true;
			IntimacaoWebApi.atualizarContrato(this.contrato)
				.then(res => {					
					this.$root.loadingSpinner = false;
					if (res.data.statusCode == 200) {
						showNotificationSucess(this, "Cadastro de Fontes", res.data.result);
						this.handleCancelEditarContrato();
						this.carregarContratos();
						if (this.idPerfilPortal == 3)
						{
							this.pegarQtdAprovacaoGestor();
						}
					} else
						showNotificationError(this, "Cadastro de Fontes", res.data.errorMessage);
				})
				.catch(res => {
					this.$root.loadingSpinner = false;
					this.loading = false;
					showNotificationError(this, "Cadastro de Fontes", "Erro ao alterar fonte.");
				});
		},
		handleChangeEditar(value, key, column) {
			const newData = [...this.dataModalLoginSenha];
			const target = newData.filter(item => key === item.key)[0];
			const columnClear = column == 'hash' ? 'image64' : '';
			if (target) {
				target[column] = value;
				if (columnClear != '')
					target[columnClear] = '';
				this.dataModalLoginSenha = newData;
			}
		},
		edit(key) {
			const newData = [...this.dataModalLoginSenha];
			const target = newData.filter(item => key === item.key)[0];
			this.editingKey = key;
			if (target) {
				target.editable = true;
				this.dataModalLoginSenha = newData;
			}
		},
		excluir(key) {
			const newData = [...this.dataModalLoginSenha];
			const newCacheData = [...this.cacheData];
			const target = newData.filter(item => key != item.key);
			const targetCache = newCacheData.filter(item => key != item.key);
			this.dataModalLoginSenha = target;
			this.cacheData = targetCache;
		},
		save(key) {
			const newData = [...this.dataModalLoginSenha];
			const newCacheData = [...this.cacheData];
			const target = newData.filter(item => key === item.key)[0];
			const targetCache = newCacheData.filter(item => key === item.key)[0];
			if (target && targetCache) {
				delete target.editable;
				this.dataModalLoginSenha = newData;
				Object.assign(targetCache, target);
				this.cacheData = newCacheData;
			}
			this.editingKey = '';
		},
		cancel(key) {
			const newData = [...this.dataModalLoginSenha];
			const target = newData.filter(item => key === item.key)[0];
			this.editingKey = '';
			if (target) {				
				Object.assign(target, this.cacheData.filter(item => key === item.key)[0]);
				delete target.editable;
				this.dataModalLoginSenha = newData;
			}
		},
		formatarCampoSenhaGrid(texto){
			return texto.trim() == '' ? '' : Array(texto.trim().length+1).join("*");
		},
		pegarQtdAprovacaoGestor() {
			return this.$store
				.dispatch(LOAD_QTDAPROVACAO, this.$store)
				// .then()
				.catch(erro => {
					showNotificationError(this, "Home", error.res.Message);
				});
		},
		recuperarClientes() {
			IntimacaoWebApi.getListarClientes().then(res => {
				if (res.data.statusCode != 200) {
					showNotificationError(this, "Cadastro de Fontes", res.data.errorMessage);
					return;
				} else if (typeof res.data.result == "string") {
					showNotificationSucess(this, "Cadastro de Fontes", res.data.result);
				} else {
					this.clientes = res.data.result;
				}
			})
			.catch(res => {
				showNotificationError(this, "Cadastro de Fontes", "Erro ao tentar carregar clientes.");
			});
		},
		handleClienteChange(value) {			
			this.valueUsuarioModal = null;
			this.usuariosModal = [];
			this.valuePerfilTribunalModal = null;
			this.perfisTribunalModal = [];
			this.dataFontes = [];
			this.valueCliente = value;			
			this.recuperarUsuario(this.valueCliente);
		},
		handleChangeUsuarioModal(value)
		{
			this.valuePerfilTribunalModal = null;
			this.perfisTribunalModal = [];
			this.valueUsuarioModal = value;
			this.getPerfilTribunalExibicaoUsuarioModal(this.valueUsuarioModal);
		},
		recuperarUsuario(idCliente) {
			if (idCliente != undefined && idCliente != null){
				IntimacaoWebApi.getUsuarioCliente(idCliente).then(res => {
					if (res.data.statusCode != 200) {
						showNotificationError(this, "Cadastro de Fontes", res.data.errorMessage);
						return;
					} else if (typeof res.data.result == "string") {
						showNotificationSucess(this, "Cadastro de Fontes", res.data.result);
					} else {
						this.usuariosModal = res.data.result;
					}
				});
			}
		},
		formatarDataLocal(data, isDateTime, format) {
			return Helpers.formatarData(data, isDateTime, format);
		},
	},
	components: { ModalComponent }
};
</script>

<style scoped>
span {
	color: #000;
	font-family: "Segoe UI", "Segoe UI Emoji", "Segoe UI Symbol", "Courier New",
		Courier, monospace;
	font-weight: bold;
}

.tr-ant-select {
	margin: 0px 0px 10px 0px;
}

.ant-switch {
	margin: 10px 0px 10px 0px;
}

.ant-input-affix-wrapper {
	margin: 0px 0px 10px 0px;
} 

.danger {
	color: red;
}

.sucess {
	color: green;
}

.default {
	color: black;
}

.custom-filter-dropdown {
	padding: 8px;
	border-radius: 4px;
	background: #fff;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.highlight {
	background-color: rgb(255, 192, 105);
	padding: 0px;
}

.cursor {
	cursor: pointer;
}

.cursor:hover {
  color: blue;
}
</style>

<style>
.contrato-form-button {
	width: 100px;
}
</style>
